module.exports = __webpack_public_path__ + "img/tr.518f696b.png";